export const defaultGray = '#4F4F4F';
export const defaultLightBlue = '#E8EEF8';
export const defaultLightBlue2 = '#2A3B8F10';
export const defaultBlue = '#2A3B8F';
export const gray2 = '#DFE2E5';
